<template>
  <div :class="{'noselect': routerName == 'SpecialDetail'}">
    <div class="preview-tip" v-if="routerName == 'PreviewSpecialDetail'">
      <p>此为临时链接，仅用于专题预览，将在短期内失效，请勿转发！</p>
    </div>
    <div class="spe_detail">
      <div class="f-row">
        <Breadcrumb separator=">" class="breadcrumb_zdy">
          当前位置:
          <BreadcrumbItem :to="{name: 'SpecialList'}">专题Pro</BreadcrumbItem>
          <BreadcrumbItem>{{detail.title}}</BreadcrumbItem>
        </Breadcrumb>
        <!-- <div>
          <router-link :to="{name: 'SpecialList'}"><i class="iconfont-sm">&#xe661;</i> 返回上一级页面</router-link>
          <a href="javascript:history.go(-1)" ><i class="iconfont-sm">&#xe661;</i> 返回上一级页面</a>
        </div> -->
      </div>
      <div class="detail">
        <div class="spe_banner">
          <div class="img-show">
            <img :src="img_req_url + detail.logo_path" />
          </div>
          <div class="s_bnr_info">
            <div class="cnt">
              <p class="p1">{{detail.title}}</p>
              <p class="p2">{{detail.summary}}</p>
            </div>

            <Button 
              class="collect-btn on" 
              v-if="detail.is_collect"
              @click="cancelCollect('2', detail.id, delCollectCb, index)"
            >
              <i class="iconfont">&#xe66f;</i>已收藏
            </Button>
            <Button 
              class="collect-btn" 
              v-else
              @click="addCollect('2', detail.id, addCollectCb, index)"
            >
              <i class="iconfont">&#xe66f;</i>添加收藏
            </Button>

            <div class="spa">
              <Poptip
                trigger="hover"
                placement="bottom-end"
                padding="0"
                width="260"
                @on-popper-show="haddleShare()"
                @on-popper-hide="haddleShareHide"
              >
                <!-- <i class="iconfont">&#xe641;</i> -->
                <Button class="share-btn">
                  <i class="iconfont">&#xe641;</i>微信分享
                </Button>
                <div slot="content" class="share_cnt clear">
                  <div class="share_img"></div>
                  <p>
                    打开微信“扫一扫”
                    <br />点击右上角分享按钮
                  </p>
                </div>
              </Poptip>
            </div>
          </div>
        </div>
        <div class="spe_content">
          <div class="spe_content_l">
            <!-- 快讯轮播 -->
            <div class="new_topic" v-if="new_topic && new_topic.length > 0">
              <div class="new_topic_icon">
                <i></i>
              </div>
              <div class="new_topic_list">
                <swiper
                  :options="swiperOption"
                  ref="mySwiper"
                  v-if="new_topic && new_topic.length > 0"
                >
                  <swiper-slide v-for="item,index in new_topic" :key="index">
                    <div class="li_tle" @click="goDetail2(item.uid)">{{item.title}}</div>
                    <div class="li_time">{{item.create_time | time_moment('YYYY-MM-DD HH:mm')}}</div>
                  </swiper-slide>
                </swiper>
              </div>
              <div class="new_topic_more">
                <span @click="haddleNewsList(detail.id)">查看更多</span>
              </div>
            </div>

            <div class="theme_content">
              <div
                class="theme_li"
                v-for="item, mindex in theme_module"
                :key="item.module_id"
                :ref="'theme_li' + item.module_id"
                v-if="item.pid == null && (item.lock_up == 0 || isVIP || detail.is_buy == '1')"
              >
                <div class="theme_li_t">
                  <span>{{item.name}}</span>
                </div>

                <ul class="theme_li_c">
                  <li class="describe" v-if="module_text[item.module_id].length > 0">
                    <ModuleDescribe
                      :describeItem="item2"
                      :moduleId="item.module_id"
                      v-for="item2,index2 in module_text[item.module_id]"
                      :key="index2"
                    ></ModuleDescribe>
                  </li>

                  <li
                    v-for="item4,index4 in module_time_line[item.module_id]"
                    :key="'time_line' + index4"
                    class="module-li"
                  >
                    <TimeLine
                      :paramsUid="params_uid"
                      :moduleId="item.module_id"
                      :timeLineItem="item4"
                    ></TimeLine>
                  </li>

                  <li
                    v-for="item5,index5 in module_map[item.module_id]"
                    :key="'map_line' + index5"
                    class="module-li"
                    v-if="item5.map_status == 1 || (item5.map_status == 0 && routerName == 'PreviewSpecialDetail')"
                  >
                    <LogoMap :paramsUid="params_uid" :mapItem="item5"></LogoMap>
                  </li>
                  <!-- 对比 -->
                  <li
                    v-for="item7,index7 in module_tct[item.module_id]"
                    :key="'module_tct' + index7"
                    class="module-li tct"
                    v-if="item7.status == 1 || (item7.status == 0 && routerName == 'PreviewSpecialDetail')"
                  >
                    <OrgContrast
                      :cItem="item7"
                      :paramsUid="params_uid"
                      :meta="meta"
                      v-if="item7.mode_type == 0"
                    ></OrgContrast>
                    <PointTime
                      :cItem="item7"
                      :paramsUid="params_uid"
                      :meta="meta"
                      v-if="item7.mode_type == 1"
                    ></PointTime>
                    <PointTag
                      :cItem="item7"
                      :paramsUid="params_uid"
                      :meta="meta"
                      v-if="item7.mode_type == 2"
                    ></PointTag>
                    <CompanySankey
                      :cItem="item7"
                      :paramsUid="params_uid"
                      :meta="meta"
                      v-if="item7.mode_type == 3"
                    ></CompanySankey>
                  </li>

                  <li
                    v-for="item6,index6 in module_table[item.module_id]"
                    :key="'map_line' + index6"
                    class="module-li"
                    v-if="item6.table_status == 1 || (item6.table_status == 0 && routerName == 'PreviewSpecialDetail')"
                  >
                    <TableList
                      :paramsUid="params_uid"
                      :moduleId="item.module_id"
                      :tableItem="item6"
                    ></TableList>
                  </li>
                  <li
                    v-for="item6,index6 in module_ppl[item.module_id]"
                    :key="'map_ppl' + index6"
                    class="module-li"
                    v-if="item6.status == 1 || (item6.status == 0 && routerName == 'PreviewSpecialDetail')"
                  >
                    <PipelineCursor
                      :paramsUid="params_uid"
                      :moduleId="item.module_id"
                      :pplItem="item6"
                      :pplType="pplType"
                      :pplNodeForm="pplNodeForm"
                    ></PipelineCursor>
                  </li>
                  <li
                    v-for="item3,index3 in module_list[item.module_id]"
                    :key="'module_list' + index3"
                    class="module-li"
                  >
                    <ModuleLi
                      :moduleItem="item3"
                      :meta="meta"
                      :moduleId="item.module_id"
                      :moduleInsight="insight_content[item.module_id]"
                    ></ModuleLi>
                  </li>
                </ul>

                <div class="list_bottom" v-if="len[item.module_id] == 3">
                  <Button 
                    class="more_btn" 
                    @click="haddleMore(item, mindex)" 
                    :class="item['more_loading' + item.module_id] ? 'more_loading' : ''"
                    :loading="item['more_loading' + item.module_id]" 
                  >{{item['more_loading' + item.module_id] ? '加载中' : '加载更多'}}</Button>
                </div>

                <div
                  class="theme-sec"
                  v-for="secItem,secIndex in theme_module"
                  :key="secIndex"
                  :ref="'theme_li' + secItem.module_id"
                  v-if="secItem.pid == item.module_id"
                >
                  <div class="theme-sec-title">
                    <span>{{secItem.name}}</span>
                  </div>
                  <ul>
                    <li class="describe" v-if="module_text[secItem.module_id].length > 0">
                      <ModuleDescribe
                        :describeItem="secItem2"
                        :moduleId="secItem.module_id"
                        v-for="secItem2,secIndex2 in module_text[secItem.module_id]"
                        :key="secIndex2"
                      ></ModuleDescribe>
                    </li>

                    <li
                      v-for="secItem4,secIndex4 in module_time_line[secItem.module_id]"
                      :key="'time_line' + secIndex4"
                      class="module-li"
                    >
                      <TimeLine
                        :paramsUid="params_uid"
                        :timeLineItem="secItem4"
                        :moduleId="secItem.module_id"
                      ></TimeLine>
                    </li>

                    <li
                      v-for="secItem5,secIndex5 in module_map[secItem.module_id]"
                      :key="'map_line' + secIndex5"
                      class="module-li"
                      v-if="secItem5.map_status == 1 || (secItem5.map_status == 0 && routerName == 'PreviewSpecialDetail')"
                    >
                      <LogoMap :paramsUid="params_uid" :mapItem="secItem5"></LogoMap>
                    </li>

                    <!-- 对比 -->
                    <li
                      v-for="secItem7,secIndex7 in module_tct[secItem.module_id]"
                      :key="'module_tct_' + secIndex7"
                      class="module-li tct"
                      v-if="secItem7.status == 1 || (secItem7.status == 0 && routerName == 'PreviewSpecialDetail')"
                    >
                      <OrgContrast
                        :cItem="secItem7"
                        :paramsUid="params_uid"
                        :meta="meta"
                        v-if="secItem7.mode_type == 0"
                      ></OrgContrast>
                      <PointTime
                        :cItem="secItem7"
                        :paramsUid="params_uid"
                        :meta="meta"
                        v-if="secItem7.mode_type == 1"
                      ></PointTime>
                      <PointTag
                        :cItem="secItem7"
                        :paramsUid="params_uid"
                        :meta="meta"
                        v-if="secItem7.mode_type == 2"
                      ></PointTag>
                      <CompanySankey
                        :cItem="secItem7"
                        :paramsUid="params_uid"
                        :meta="meta"
                        v-if="secItem7.mode_type == 3"
                      ></CompanySankey>
                    </li>

                    <li
                      v-for="secItem6,secIndex6 in module_table[secItem.module_id]"
                      :key="'table_line' + secIndex6"
                      class="module-li"
                      v-if="secItem6.table_status == 1 || (secItem6.table_status == 0 && routerName == 'PreviewSpecialDetail')"
                    >
                      <TableList :paramsUid="params_uid" :tableItem="secItem6"></TableList>
                    </li>
                    <li
                      v-for="item6,index6 in module_ppl[secItem.module_id]"
                      :key="'map_ppl' + index6"
                      class="module-li"
                      v-if="item6.status == 1 || (item6.status == 0 && routerName == 'PreviewSpecialDetail')"
                    >
                      <PipelineCursor
                        :paramsUid="params_uid"
                        :moduleId="item.module_id"
                        :pplItem="item6"
                        :pplType="pplType"
                        :pplNodeForm="pplNodeForm"
                      ></PipelineCursor>
                    </li>
                    <li
                      v-for="secItem3,secIndex3 in module_list[secItem.module_id]"
                      :key="'module_list' + secIndex3"
                      class="module-li"
                    >
                      <ModuleLi
                        :moduleItem="secItem3"
                        :meta="meta"
                        :moduleId="secItem.module_id"
                        :moduleInsight="insight_content[secItem.module_id]"
                      ></ModuleLi>
                    </li>
                  </ul>

                  <div class="list_bottom">
                    <Button
                      class="more_btn"
                      @click="haddleMore(secItem, secIndex)"
                      v-if="len[secItem.module_id] == 3"
                      :loading="secItem['more_loading' + secItem.module_id]" 
                      :class="secItem['more_loading' + secItem.module_id] ? 'more_loading' : ''"
                    >{{secItem['more_loading' + secItem.module_id] ? '加载中' : '加载更多'}}</Button>
                  </div>
                </div>
              </div>
              <div class="theme-last">
                <div class="theme-type">
                  <span v-for="item,index in theme_types">{{item | dealName(meta.theme_type)}}</span>
                </div>
                <p
                  class="create_name"
                  v-if="isVIP || detail.is_buy != '0' || detail.theme_price == 0 || detail.price == 0"
                >（数字资讯部·编辑：{{detail.create_user_name}}）</p>
              </div>
            </div>
            <div
              class="buy-page"
              ref="buyPage"
              v-if="!isVIP && detail.is_buy == '0' && detail.theme_price > 0 && detail.price > 0"
            >
              <div class="buy-bg">
                <p>
                  ￥
                  <i>{{detail.price}}</i>/年 此内容需付费
                  <br />
                  单篇专题付费后，附赠解锁{{detail.type_arr[0] | dealName(this.meta.theme_type)}}所有专题
                </p>
                <span @click="goPay">立即解锁</span>
                <div class="right-info">
                  <img :src="$store.state.static_img_url + 'pic/lock-bg-right.png'" class="img1" />
                  <img
                    :src="$store.state.static_img_url + 'pic/lock-bg-font.png'"
                    class="img2"
                    @click="haddleGoVip"
                  />
                </div>
              </div>
            </div>

            <div class="relevant_theme">
              <p>
                猜您喜欢
                <span @click="moreTheme">
                  查看更多
                  <i class="iconfont">&#xe647;</i>
                </span>
              </p>
              <div class="list">
                <div
                  class="li"
                  v-for="item,index in relevant_theme"
                  :key="index"
                  @click="goRelevantTheme(item.uid)"
                >
                  <div class="img">
                    <img :src="img_req_url + item.share_logo_path" />
                  </div>
                  <div class="title">
                    <p>{{item.title}}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="spe_content_r">
            <!-- 右侧导航 -->
            <div class="model-slider" ref="modelSlider">
              <p>导航目录</p>
              <div class="model-slider-cnt">
                <ul v-if="theme_module && theme_module.length > 0">
                  <li v-for="item,index in theme_module" :key="index" v-if="!item.pid">
                    <a
                      @click="haddleModelSlider(item,index)"
                      :class="{active: slideModuleId == item.module_id}"
                    >{{item.name}}</a>
                    <span v-if="item.lock_up == 1">
                      <img
                        :src="$store.state.static_img_url + 'pic/lock-open.png'"
                        v-if="isVIP || detail.is_buy == '1'"
                        alt="开"
                      />
                      <img
                        :src="$store.state.static_img_url + 'pic/lock-close.png'"
                        v-else
                        alt="关"
                        @click="goPay"
                      />
                    </span>
                    <ul>
                      <li
                        v-for="item2,index2 in theme_module"
                        :key="index2"
                        v-if="item2.pid == item.module_id"
                      >
                        <a
                          @click="haddleModelSlider(item2,index)"
                          :class="{active: slideModuleId == item2.module_id}"
                        >{{item2.name}}</a>
                        <span v-if="item2.lock_up == 1">
                          <img
                            :src="$store.state.static_img_url + 'pic/lock-open.png'"
                            v-if="isVIP || detail.is_buy == '1'"
                            alt="开"
                          />
                          <img
                            :src="$store.state.static_img_url + 'pic/lock-close.png'"
                            v-else
                            alt="关"
                            @click="goPay"
                          />
                        </span>
                      </li>
                    </ul>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <Spin fix v-if="detail_loading_1 || detail_loading_2">
          <Icon type="ios-loading" size="18" class="demo-spin-icon-load"></Icon>
          <div>Loading</div>
        </Spin>
      </div>
    </div>
    <FinishInfoAndPay ref="pay" :pricearr="[detail]" :buytype="'13'"></FinishInfoAndPay>
  </div>
</template>
<script>
import {
  themeInfo,
  themeModule,
  themeNewsTopic,
  addPuv,
  previewTheme,
  themeModulContentAll,
  getRelevantTheme
} from "../../service";
import { swiper, swiperSlide } from "vue-awesome-swiper";
import { collect_mixin } from "js/collect_mixin";
import { get_meta } from "js/get_meta";
import { userInfo } from "js/userInfo";
import { left_scroll } from "js/left_scroll";
import ModuleLi from "./components/ModuleLi";
import ModuleDescribe from "./components/ModuleDescribe";
import TimeLine from "./components/TimeLine";
import LogoMap from "./components/LogoMap";
import TableList from "./components/TableList";
import OrgContrast from "./components/OrgContrast";
import PointTime from "./components/PointTime";
import PointTag from "./components/PointTag";
import CompanySankey from "./components/CompanySankey";
import PipelineCursor from "./components/PipelineCursor";
import FinishInfoAndPay from "../../components/FinishInfoAndPay";

import filter from "js/filter";

export default {
  metaInfo() {
    return {
      title: this.meta_title
    }
  },
  mixins: [collect_mixin, userInfo, get_meta, left_scroll],
  inject: ["reload", "login", "globalInsertRecords"],
  provide() {
    return {
      goDetail: this.goDetail,
      goAuthor: this.goAuthor
    };
  },
  data() {
    return {
      detail_loading_1: true,
      detail_loading_2: true,
      detail: "",
      theme_module: [],
      page: {},
      module_list: {},
      insight_content: {},
      module_map: {},
      module_table: {},
      module_text: {},
      module_time_line: {},
      module_tct: {},
      module_ppl: {},
      pplType:[],
      pplNodeForm:[],
      len: {},
      new_topic: [],
      swiperOption: {
        autoplay: true,
        speed: 300,
        direction: "vertical",
        loop: true,
        observer: true, //修改swiper自己或子元素时，自动初始化swiper
        observeParents: true //修改swiper的父元素时，自动初始化swiper
      },
      scrollTop: 0,
      themeLiTopArr: [],
      slideModuleId: "",
      theme_types: [],
      relevant_theme: [],

      meta_title: '动脉橙-数字健康产业信息服务商'
    };
  },
  computed: {
    theme_switch() {
      return this.$store.state.theme_switch;
    },
    img_req_url() {
      return this.$store.state.img_req_url;
    },
    swiper() {
      return this.$refs.mySwiper.swiper;
    },
    link_keyword() {
      var url = location.search;
      var theRequest = new Object();
      if (url.indexOf("?") != -1) {
        var str = url.substr(1);
        var strs = str.split("&");
        for (var i = 0; i < strs.length; i++) {
          theRequest[strs[i].split("=")[0]] = unescape(strs[i].split("=")[1]);
        }
      }
      return theRequest;
    },
    params_uid() {
      if (this.$route.name === "SpecialDetail") {
        return this.$route.params.uid;
      } else {
        return this.link_keyword.theme_uid;
      }
    },
    routerName() {
      return this.$route.name;
    }
  },
  components: {
    swiper,
    swiperSlide,
    ModuleLi,
    ModuleDescribe,
    TimeLine,
    LogoMap,
    TableList,
    OrgContrast,
    PointTime,
    PointTag,
    CompanySankey,
    FinishInfoAndPay,
    PipelineCursor
  },
  methods: {
    /**
     * 专题模块内容第一页
     * theme_id int 专题id
     * module_id array 专题模块数组
     */
    async getThemeModulContentAll(t_id, m_id) {
      let res = await themeModulContentAll(
        {
          theme_id: t_id,
          module_id: m_id,
          is_preview: this.$route.name === "PreviewSpecialDetail" ? 1 : ""
        },
        error => this.$Message.error("请求错误！")
      );
      if (res.status == "success") {
        res.res.map(a => {
          a.content.map(b => this.module_list[a.module_id].push(b));
          a.module_insight_content.map(b =>
            this.module_text[a.module_id].push(b)
          );
          a.insight_theme_content.map(b =>
            this.insight_content[a.module_id].push(b)
          );
          a.module_time_line.map(b =>
            this.module_time_line[a.module_id].push(b)
          );
          a.module_map.map(b => this.module_map[a.module_id].push(b));
          a.module_table.map(b => this.module_table[a.module_id].push(b));
          a.module_tct.map(b => this.module_tct[a.module_id].push(b));
          a.module_ppl.map(b => this.module_ppl[a.module_id].push(b));
          this.len[a.module_id] = a.content.length;
        });
        this.pplType = res.value
        this.pplNodeForm = res.node_form
        this.detail_loading_1 = false;
        this.$nextTick(() => this.listenerScroll("model-slider"));
      } else {
        this.$Message.error(res.message);
      }
    },
    async getThemeInfo(uid) {
      this.module_list = {};
      let res = await themeInfo(
        { user_key: this.$store.state.user_key, theme_uid: uid },
        error => this.$Message.error("请求错误！")
      );
      if (res.status == "success") {
        this.$set(this.$data, "detail", res.info[0]);
        this.globalInsertRecords({
          content_type: 88,
          enter_type: 47,
          view_type: 2,
          content_id: this.detail.id,
        })

        this.meta_title = this.detail.title + '-动脉橙'
        if (this.meta.theme_type) {
          this.detail.theme_price = res.info[0].price;
          let index = this.meta.theme_type.findIndex(
            a => a.id == this.detail.type_arr[0]
          );
          if(index > -1) {
            this.detail.price = this.meta.theme_type[index].price;
          }
        }
        res.module.forEach(item => {
          item['more_loading' + item.module_id] = false
        })
        this.$set(this.$data, "theme_module", res.module);
        
        this.$set(this.$data, "theme_types", res.info[0].type_arr);
        this.getRelevantTheme(
          res.info[0].id,
          res.info[0].tag_arr,
          res.info[0].type_arr
        );
        if (res.module.length > 0) {
          let m_list = [];
          res.module.map(a => {
            this.module_list[a.module_id] = [];
            this.insight_content[a.module_id] = [];
            this.module_text[a.module_id] = [];
            this.module_time_line[a.module_id] = [];
            this.module_map[a.module_id] = [];
            this.module_tct[a.module_id] = [];
            this.module_table[a.module_id] = [];
            this.module_ppl[a.module_id] = [];
            this.page[a.module_id] = 1;
            this.len[a.module_id] = 0;
            if (
              !this.isVIP &&
              this.detail.is_buy == "0" &&
              this.detail.theme_price > 0 &&
              this.detail.price > 0
            ) {
              if (a.lock_up == 0) {
                m_list.push(a.module_id);
              }
            } else {
              m_list.push(a.module_id);
            }
          });
          this.getThemeModulContentAll(this.detail.id, m_list);
          let index = res.module.findIndex(b => b.pid == null);
          this.slideModuleId = res.module[index].module_id;
        } else {
          this.detail_loading_1 = false;
        }

        this.$nextTick(() => {
          this.getSpecialNewsList(res.info[0].id);
          this.getAddPuv();
        });
      } else {
        this.$Message.error(res.message);
      }
    },
    /**
     * “猜你喜欢”列表
     */
    async getRelevantTheme(id, tag_arr, type_arr) {
      this.module_list = {};
      let res = await getRelevantTheme(
        {
          id: id,
          type_arr: type_arr,
          tag_arr: tag_arr
        },
        error => this.$Message.error("请求错误！")
      );
      if (res.status == "success") {
        this.$set(this.$data, "relevant_theme", res.res.slice(0, 3));
      } else {
        this.$Message.error(res.message);
      }
    },
    /**
     * 加载模块数据
     * data_id 对应模块module_id
     * is_more 是否加载更多 0否 1是
     */
    async getThemeModule(data_id, is_more, mindex) {
      let module_params = {
        module_id: data_id,
        theme_id: this.detail.id,
        page: this.page[data_id]
      };
      let res = await themeModule(module_params, error =>
        this.$Message.error("请求错误！")
      );
      if (res.status == "success") {
        res.res.map(a => this.module_list[data_id].push(a));
        res.module_text_content.map(a => this.module_text[data_id].push(a));
        res.insight_theme_content.map(a =>
          this.insight_content[data_id].push(a)
        );
        res.module_time_line.map(a => this.module_time_line[data_id].push(a));
        res.module_map.map(a => this.module_map[data_id].push(a));
        res.module_tct.map(a => this.module_tct[data_id].push(a));
        res.module_table.map(a => this.module_table[data_id].push(a));
        res.module_ppl.map(a => this.module_ppl[data_id].push(a));

        this.len[data_id] = res.res.length;
        this.detail_loading_1 = false;
        this.$nextTick(() => this.listenerScroll("model-slider"));
        this.$forceUpdate();
        this.$previewRefresh();
        if (this.len[data_id] == 0 && is_more == 1) {
          this.$Message.warning('数据已加载完，没有更多了');
        }
        this.$set(this.theme_module[mindex], 'more_loading' + data_id, false);
      } else {
        this.$Message.error(res.message);
      }
    },
    async getSpecialNewsList(uid) {
      let params = {
        page: 1,
        theme_id: uid
      };
      let res = await themeNewsTopic(params, error =>
        this.$Message.error("请求错误！")
      );
      if (res.status == "success") {
        this.$set(this.$data, "new_topic", res.res);
        this.detail_loading_2 = false;
      } else {
        this.$Message.error(res.message);
      }
    },
    haddleMore(item, mindex) {
      this.$set(this.theme_module[mindex], 'more_loading' + item.module_id, true);
      this.page[item.module_id]++;
      this.getThemeModule(item.module_id, 1, mindex);
    },
    haddleNewsList(uid) {
      _czc.push([
        "_trackEvent",
        "专题详情页",
        "快讯查看更多点击（" + this.detail.title + "）"
      ]);
      const { href } = this.$router.resolve({
        name: "SpecialNewsList",
        params: { uid: uid }
      });
      window.open(href, "_blank");
    },
    goDetail(uid, type, id) {
      if (type == "0") {
        const href = this.$store.state.index2_path + '/' + id
        window.open(href, '_blank')
      } else if (type == "1") {
        const href = this.$store.state.index2_path + '/newsDetail/' + uid
        window.open(href, "_blank");
      } else if (type == "2") {
        window.open(this.$store.state.index2_path + "/seriesD/" + id);
      } else if (type == "3") {
        const { href } = this.$router.resolve({
          name: "SpecialDetail",
          params: { uid: uid }
        });
        window.open(href, "_blank");
      } else if (type == "5") {
        const { href } = this.$router.resolve({
          name: "PolicyDetail",
          params: { uid: uid }
        });
        window.open(href, "_blank");
      } else if (type == "11") {
        const { href } = this.$router.resolve({
          name: "ReportDetail",
          params: { uid: uid }
        });
        window.open(href, "_blank");
      }
    },
    goDetail2(uid) {
      _czc.push([
        "_trackEvent",
        "专题详情页",
        "快讯详情点击（" + this.detail.title + "）"
      ]);
      const href = this.$store.state.index2_path + '/newsDetail/' + uid
      window.open(href, "_blank");
    },
    haddleGoVip() {
      const { href } = this.$router.resolve({ name: "BuyVip" });
      window.open(href, "_blank");
    },
    haddleShare() {
      let share_link = window.location.href;
      jQuery($(".share_img")).qrcode({
        width: 100,
        height: 100,
        correctLevel: 0,
        text: share_link
      });
      _czc.push([
        "_trackEvent",
        "专题详情页",
        "分享专题（" + this.detail.title + "）"
      ]);
    },
    haddleShareHide() {
      $(".share_img").html("");
    },
    async getAddPuv() {
      let puv_params = {
        user_key: this.user_key,
        url: window.location.href,
        row_id: this.detail.id
      };
      let res = await addPuv(puv_params, error =>
        this.$Message.error("请求错误！")
      );
    },
    goAuthor(val) {
      let link_key = window.btoa(val);
      window.open(
        this.$store.state.index2_path + "/Article/authorArticle/keyword/" + link_key
      );
    },
    /**
     * 预览
     */
    async getPreviewTheme(uid, sign, time) {
      this.module_list = {};
      let preview_params = {
        theme_uid: uid,
        sign: sign,
        timestamp: time
      };
      let res = await previewTheme(preview_params, error =>
        this.$Message.error("请求错误！")
      );
      if (res.status == "success") {
        this.$set(this.$data, "detail", res.res[0]);
        this.meta_title = this.detail.title + '-动脉橙'
        res.module.forEach(item => {
          item['more_loading' + item.module_id] = false
        })
        this.$set(this.$data, "theme_module", res.module);
        if (res.module.length > 0) {
          let m_list = [];
          res.module.map(a => {
            this.module_list[a.module_id] = [];
            this.insight_content[a.module_id] = [];
            this.module_text[a.module_id] = [];
            this.module_time_line[a.module_id] = [];
            this.module_map[a.module_id] = [];
            this.module_tct[a.module_id] = [];
            this.module_table[a.module_id] = [];
            this.module_ppl[a.module_id] = [];
            this.page[a.module_id] = 1;
            this.len[a.module_id] = 0;
            m_list.push(a.module_id);
          });
          this.getThemeModulContentAll(this.detail.id, m_list);
          let index = res.module.findIndex(b => b.pid == null);
          this.slideModuleId = res.module[index].module_id;
        } else {
          this.detail_loading_1 = false;
        }

        this.$nextTick(() => {
          this.getSpecialNewsList(res.res[0].id);
          this.listenerScroll("model-slider");
        });
      } else {
        this.$Message.error(res.message);
      }
    },
    /**
     * 监听滚动条改变
     * m=监听的值
     */
    haddleScroll(m) {
      if (this.$refs.modelSlider) {
        this.scrollTop =
          document.documentElement.scrollTop || document.body.scrollTop; //滚动条的值
        if (this.scrollTop > m) {
          this.$refs.modelSlider.classList.add("on");
        } else {
          this.$refs.modelSlider.classList.remove("on");
        }
        this.haddleSlideModule();
      }
    },
    /**
     * 右侧导航点击事件
     * item 点击的对象
     */
    haddleModelSlider(item, index) {
      // _czc.push(['_trackEvent', '专题详情页', this.detail.title+'导航目录点击（'+item.name+'）'])
      let targetTop;

      if (this.isVIP || this.detail.is_buy == "1" || this.detail.price == 0) {
        targetTop = this.$refs["theme_li" + item.module_id][0].offsetTop + 26;
      } else {
        if (item.lock_up == 0) {
          targetTop = this.$refs["theme_li" + item.module_id][0].offsetTop + 26; //滚动条目标位置
        } else if (item.lock_up == 1) {
          targetTop = this.$refs["buyPage"].offsetTop + 26;
        }
      }
      let _this = this;
      $("html, body").animate({ scrollTop: targetTop }, 200, function() {
        _this.slideModuleId = item.module_id;
      });
    },
    /**
     * 导航高亮
     */
    haddleSlideModule() {
      this.themeLiTopArr = [];
      this.theme_module.map(a => {
        if (this.isVIP || this.detail.is_buy == "1" || (this.detail.price == 0 && a.lock_up == 0)) {
          this.themeLiTopArr.push({
            module_id: a.module_id,
            offset_top: this.$refs["theme_li" + a.module_id][0].offsetTop
          });
        } else {
          if (a.lock_up == 0) {
            this.themeLiTopArr.push({
              module_id: a.module_id,
              offset_top: this.$refs["theme_li" + a.module_id][0].offsetTop
            });
          }
        }
      });
      this.themeLiTopArr.sort((a, b) => a.offset_top - b.offset_top);
      for (let i = 0; i < this.themeLiTopArr.length; i++) {
        if (this.scrollTop >= this.themeLiTopArr[i].offset_top) {
          this.slideModuleId = this.themeLiTopArr[i].module_id;
        }
      }
      this.$forceUpdate();
    },
    addCollectCb() {
      this.detail.is_collect = 1;
    },
    delCollectCb() {
      this.detail.is_collect = 0;
    },
    goPay() {
      if (this.user_key) {
        if (this.user.name && this.user.compName && this.user.title) {
          this.$refs["pay"].showInfo(
            2,
            filter.dealName(this.detail.type_arr[0], this.meta.theme_type) +
              "-专题Pro",
            this.haddleCreated
          );
        } else {
          this.$refs["pay"].showInfo(
            1,
            filter.dealName(this.detail.type_arr[0], this.meta.theme_type) +
              "-专题Pro",
            this.haddleCreated
          );
        }
      } else {
        this.login();
      }
    },
    haddleCreated() {
      this.detail_loading_1 = true;
      this.detail_loading_2 = true;
      if (this.$route.name === "SpecialDetail") {
        this.getThemeInfo(this.$route.params.uid);
      } else {
        this.getPreviewTheme(
          this.link_keyword.theme_uid,
          this.link_keyword.sign,
          this.link_keyword.timestamp
        );
      }
    },
    goRelevantTheme(uid) {
      const { href } = this.$router.resolve({
        name: "SpecialDetail",
        params: { uid: uid }
      });
      window.open(href, "_blank");
    },
    moreTheme() {
      const { href } = this.$router.resolve({ name: "SpecialList" });
      window.open(href, "_blank");
    }
  },
  created() {
    this.getMeta(
      [
        "theme_type",
        "address",
        "entity_ntag",
        "round",
        "annotation_tag",
        "unit",
        "tct_business_nature"
      ],
      this.haddleCreated
    );
  },
  mounted() {
    if (this.$route.name === "SpecialDetail") {
      document.oncontextmenu = new Function("event.returnValue=false");
      document.onselectstart = new Function("event.returnValue=false");
    }
    let modelSliderTop = this.$refs.modelSlider.offsetTop + 26;
    this.haddleScroll(modelSliderTop);

    this.$nextTick(() => {
      window.onscroll = () => {
        this.listenerScroll("model-slider");
        this.haddleScroll(modelSliderTop);
      };
      window.onresize = () => {
        this.listenerScroll("model-slider");
      };
    });
  },
  beforeDestroy() {
    document.oncontextmenu = new Function("event.returnValue=true");
    document.onselectstart = new Function("event.returnValue=true");
    window.onscroll = "";
    window.onresize = "";
  }
};
</script>
<style lang="stylus" scoped>
@import '~styles/common.stylus'
.noselect
  -webkit-touch-callout: none; /* iOS Safari */
  -webkit-user-select: none; /* Chrome/Safari/Opera */
  -khtml-user-select: none; /* Konqueror */
  -moz-user-select: none; /* Firefox */
  -ms-user-select: none; /* Internet Explorer/Edge */
  user-select none
.spe_detail
  padding-top 16px
  width 1020px
  margin 0 auto
  .detail
    position relative
    min-height 310px
    margin-top 16px
  .spe_banner
    width 100%
    height 310px
    font-size 0
    position relative
    .img-show
      width 740px
      height 310px
      position relative
      overflow hidden
      img
        position absolute
        top 50%
        left 50%
        width 100%
        min-height 310px

        translateXY50()
    .s_bnr_info
      position absolute
      font-size 14px
      translateY50()
      right 0
      top 50%
      width 560px
      height 280px
      line-height 1
      commonBgColor(rgba(31, 35, 48, 0.9), rgba(255, 255, 255, 0.95))
      commonShadow(5px 5px 10px rgba(0, 0, 0, 0.5), 0px 5px 10px 0px rgba(121, 133, 143, 0.1))
      z-index 5
      display: flex;
      align-items: center;
      padding: 0 30px 20px;
      .p1
        font-size: 26px
        line-height: 34px
        margin -5px 0
        commonColor(#FFFFFF, #333333)
        font-weight bold
      .p2
        font-size: 14px
        margin-top: 18px
        line-height: 20px
        commonColor(#FFFFFF, #666666)
      .collect-btn
        position absolute
        right 150px
        bottom 20px
      .collect-btn, .share-btn
        height 32px
        background #FA5A00
        border-radius 6px
        font-size 14px
        color #fff
        border-color #FA5A00
        line-height 1
        box-shadow none
        >>> span
          display flex
          align-items center
          justify-content center
          .iconfont
            font-size 14px
            margin-right 8px
        &:hover
          background #FF4800
          border-color #FF4800
        &.on
          color #666666
          border-color #F5F5F5
          background #F5F5F5
          >>> span
            .iconfont
              color #FA5A00
          &:hover
            background #f0f0f0
            border-color #f0f0f0
      .share-btn
        color #2EC66B
        border-color #2EC66B
        background none
        >>> span
          .iconfont
            font-size 16px
        &:hover
          background #2EC66B
          border-color #2EC66B
          color #fff
      .spa
        position absolute
        right 30px
        bottom 20px
        & >>> .ivu-poptip
          .ivu-poptip-popper
            .ivu-poptip-inner
              border-radius 0
              .share_cnt
                padding 10px
                display flex
                justify-content space-between
                width 260px
                align-items: center
                .share_img
                  width 100px
                  height 100px
                  background #f0f0f0
                p
                  line-height 20px
                  color #666
                  font-size 14px
  .spe_content
    margin-top 20px
    display flex
    &_l
      flex 0 0 740px
      padding-bottom 20px
      .new_topic
        commonBgColor(#1F2330, #FFFFFF)

        border-radius 2px
        padding 21px 20px
        display flex
        margin-bottom 20px
        &_icon
          margin-top -1px
          i
            width 57px
            height 18px

            commonBgImg('~pic/topic_icon2.png', '~pic/topic_icon.png')

            background-size 100% !important
            background-repeat no-repeat !important
            display inline-block
            vertical-align top
        &_list
          flex auto
          .swiper-container
            width 100%
            height 18px
          .swiper-wrapper
            .swiper-slide
              >div
                line-height 18px
                float left
              .li_tle
                margin-left 20px
                font-size 14px

                commonColor(#E9E9EB, #333333)

                max-width 400px

                ellipsis()

                cursor pointer
                &:hover
                  color rgba(250, 122, 80, 1)
              .li_time
                font-size 12px

                commonColor(#797B83, #aaaaaa)

                margin-left 20px
        &_more
          font-size 12px
          line-height 18px
          color rgba(250, 122, 80, 1)
          cursor pointer
          white-space nowrap
          span:hover
            color #FC9C7C
      .theme_content
        padding 20px 20px 0

        commonBgColor(#1F2330, #FFFFFF)

        .theme_li
          padding-bottom 40px
          &_t
            commonBgImg('~pic/theme_tle.png', '~pic/theme_tle1.png')

            background-repeat no-repeat !important
            background-size 100% auto !important
            background-position left 11px !important
            span
              font-size 18px
              color #FFFFFF
              display inline-block
              vertical-align top
              padding 11px 20px
              background-color #FF8936
              position relative
              line-height 1
              font-weight 600
              &:before
                content ''
                position absolute
                width 16px
                height 40px
                background-image url('~pic/s_t.png')
                background-size auto 100%
                background-repeat no-repeat
                background-position top right
                right -14px
                top 0
          &_c
            margin-top -10px
            li
              margin-top 30px
              &.tct
                div+div
                  margin-top 30px
              &.describe
                margin-bottom -10px
                padding-bottom 20px
                border-bottom 1px solid

                commonBorderColor(#40444f, #e8e8e8)
        .list_bottom
          text-align center
          .more_btn 
            border 1px solid rgba(250, 122, 80, 1)
            margin-top 20px
            border-radius 18px
            display inline-block
            width 108px
            height 36px
            background transparent
            color rgba(250, 122, 80, 1)
            cursor pointer
            &:hover
              color #FC9C7C
              border-color #FC9C7C
            &:focus
              box-shadow: none
          .more_loading
            border 0
        .theme-sec
          margin-top 30px
          ul
            margin-top -10px
            li
              margin-top 30px
              &.describe
                margin-bottom -10px
                padding-bottom 20px
                border-bottom 1px dashed

                commonBorderColor(#40444f, #e9e9e9)
          &-title
            span
              font-size 18px
              color #E26913
              display inline-block
              vertical-align top
              padding-left 14px
              font-weight 600
              position relative
              &:before
                content ''
                position absolute
                width 4px
                height 18px
                border-radius 2px
                background linear-gradient(180deg, #FFB75E 0%, #F46B45 100%)
                top 0
                left 0
      .theme-last
        display flex
        justify-content space-between
        padding-bottom 20px
        .theme-type
          margin-top -10px
          margin-left -10px
          span
            display inline-block
            vertical-align top

            commonColor(#BCBDC1, #666666)
            commonBgColor(#35383F, #F9F9F9)

            padding 5px 8px
            font-size 12px
            margin-top 10px
            margin-left 10px
        .create_name
          color #bcbdc1
          font-size 14px
          line-height 22px
          text-align right
          white-space nowrap
          margin-left 10px
      .relevant_theme
        margin-top 30px
        > p
          font-size 18px
          font-weight 600

          commonColor(#FFFFFF, #333333)

          display flex
          justify-content space-between
          span
            color rgba(250, 122, 80, 1)
            font-size 12px
            font-weight normal
            cursor pointer
            line-height 18px
            &:hover
              color #FC9C7C
            i
              font-size 12px
        .list
          display flex
          margin-top 12px
          .li
            flex 0 0 240px
            cursor pointer
            &+.li
              margin-left 10px
            .img
              width 240px
              height 150px
              overflow hidden
              img
                width 100%
                height 100%
                display block
                transition all 0.2s
            &:hover
              img
                transform scale(1.1)
              .title p
                color rgba(250, 122, 80, 1) !important
            .title
              padding 10px 20px

              commonBgColor(#1F2330, #ffffff)

              p
                commonColor(#E9E9EB, #666666)

                font-size 14px
                line-height 22px
                height 44px
                display -webkit-box
                overflow hidden
                text-overflow ellipsis
                word-break break-all
                -webkit-box-orient vertical
                -webkit-line-clamp 2
    &_r
      flex auto
      margin-left 20px
      .model-slider
        width 260px
        position relative
        p
          width 100%
          font-size 20px

          commonColor(#FFFFFF, #333333)

          font-weight 600
          padding 0 30px 20px
        &-cnt
          width 100%
          overflow auto
          > ul
            padding 0 30px
            position relative
            padding 12px 0 37px
            &:before
              content ''
              position absolute
              width 0
              border-left 1px dashed

              commonBorderColor(#40444f, #E9E9E9)

              left 37px
              top 0
              bottom 25px
            > li
              position relative
              margin-left 37px
              padding-left 30px
              &+li
                margin-top 24px
              > span
                display inline-block
                vertical-align top
                font-size 0
                line-height 1
                cursor pointer
                margin-left 6px
                img
                  width 20px
              > a
                font-size 16px

                commonColor(#e9e9eb, #333333)

                white-space normal
                line-height 22px
                vertical-align top
                &:hover
                  color rgba(250, 122, 80, 1)
                &:before
                  content ''
                  position absolute
                  width 14px
                  height 14px

                  commonBgImg('~pic/s_nav.png', '~pic/s_nav2.png')

                  background-repeat no-repeat !important
                  background-position center !important
                  background-size 8px !important
                  left -6px
                  top 3px
                &.active
                  color rgba(250, 122, 80, 1)
                  font-weight 600
                  &:before
                    commonBgImg('~pic/s_nav_on.png', '~pic/s_nav_on2.png')

                    background-size 14px !important
              > ul
                li
                  position relative
                  margin-top 21px
                  > span
                    display inline-block
                    vertical-align top
                    font-size 0
                    line-height 1
                    cursor pointer
                    margin-left 6px
                    img
                      width 20px
                  > a
                    font-size 14px

                    commonColor(#BCBDC1, #666666)

                    line-height 22px
                    white-space normal
                    display inline-block
                    vertical-align top
                    &.active
                      color rgba(250, 122, 80, 1)
                      font-weight 600
                      &:before
                        content ''
                        position absolute
                        width 14px
                        height 14px

                        commonBgImg('~pic/s_nav_on.png', '~pic/s_nav_on2.png')

                        background-size 14px !important
                        left -36px
                        top 3px
                    &:hover
                      color rgba(250, 122, 80, 1)
        &.on
          position fixed
          top 84px
          bottom 20px
          .model-slider-cnt
            position absolute
            top 40px
            bottom 0
          p
            position absolute
            top 0
  >>> .ivu-spin-fix .ivu-spin-main
    top 165px
.preview-tip
  background-color #ffecdc
  position fixed
  top 64px
  width 100%
  z-index 20
  p
    text-align center
    line-height 28px
    font-size 12px
    color #FF8936
.buy-page
  width 100%
  height 440px
  position relative

  commonBgImg('~pic/theme-lock-bg.png', '~pic/theme-lock-bg-l.png')

  background-repeat no-repeat
  background-size 100% 100%
  .buy-bg
    position absolute
    width 642px
    height 154px
    top 143px
    left 49px
    padding 20px
    background-image url('~pic/lock-bg.png')
    background-repeat no-repeat
    background-size 100% 100%
    p
      font-size 15px
      line-height 22px
      font-weight bold
      color #333333
      text-align center
      margin-top 16px
      > i
        color rgba(250, 122, 80, 1)
        font-style normal
    span
      display block
      margin 10px auto 0
      width 88px
      height 30px
      background rgba(250, 122, 80, 1)
      color #F2F2F2
      font-size 14px
      box-shadow 0px 5px 20px 0px rgba(24, 141, 237, 0.29)
      border-radius 4px
      text-align center
      line-height 30px
      cursor pointer
      &:hover
        background #FC9C7C
    .right-info
      position absolute
      right 20px
      bottom 20px
      font-size 0
      .img1
        width 35px
        height 32px
        transition all 0.3s
      .img2
        position absolute
        right 6px
        bottom 6px
        z-index 2
        opacity 0
        width 61px
        transition all 0.1s
        cursor pointer
    &:hover
      .img1
        width 102px
        height 114px
      .img2
        opacity 1
</style>
